import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Helpers } from '../../../helpers';
import { ScriptLoaderService } from '../../../_services/script-loader.service';


@Component({
    selector: ".m-grid__item.m-grid__item--fluid.m-grid.m-grid--ver-desktop.m-grid--desktop.m-body",
    templateUrl: "./subheader-type-search.component.html",
    encapsulation: ViewEncapsulation.None,
})
export class SubheaderTypeSearchComponent implements OnInit {


    constructor() {

    }
    ngOnInit() {

    }

}


// WEBPACK FOOTER //
// D:/Finca/Finca UI/UI/src/app/theme/pages/subheader-type-search/subheader-type-search.component.ts